import { classNameGenerator } from "@/utils"
import styles from "./HeroSection.module.scss"
import Slider from "react-slick";
import { useAppSelector, useWindowDimensions } from "@/hooks";
import Typography from "@/foundation/Typography/V2";
import Image from "next/image";
import { Button } from "@/components/Atoms";
import { useRouter } from "next/router";

const HeroSection = () => {
  const cls = classNameGenerator(styles)
  const { data } = useAppSelector((state) => state.healthProgramV1);
  const router = useRouter();
  const { width } = useWindowDimensions();

  if (!data?.heroSection) {
    return <></>
  }

  const { heroSection } = data || {}
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const Cards = (_val, index) => {
    return (
      <div key={index} className={cls("cardWrapper")} style={{ position: "relative" }}>
        <Image
          src={width > 600 ? _val?.bgImage : _val?.mobBgImage}
          alt="Homepage Banner"
          fill
          className={cls("hero-image")}
          priority
        />
        {/* <div className={cls("overlay-blur")} /> */}
        <div className={cls("contentWrapper")}>
          <div className={cls("textContainer")}>
            <Typography
              variant="heading1"
              className={cls("title")}
              dangerouslySetInnerHTML={{ __html: _val?.title }}
            />

            <Typography
              variant="paragraph1"
              className={cls("description")}
              dangerouslySetInnerHTML={{ __html: _val?.description }}
            />

            <div className={cls("buttonGroup")}>
              <Button 
              variant="primary" 
              className={cls("cta")}
              onClick={() => router.push(_val?.ctaLink)}
              >
                Explore all Products
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className={cls("heroWrapper")}>
      <div className={cls("heroContainer")}>
        <Slider {...settings}>
          {
            heroSection.map((_val, index) => (
              <Cards {..._val} index={index} />
            ))
          }
        </Slider>
      </div>
    </section>
  )
}

export default HeroSection